export default "__VITE_ASSET__Be7kJgd7__"